import { useZocksAuth } from '../../components/ScopedBlock/hooks'
import {
  CUSTOM_INTEGRATION_ADMIN_SCOPE,
  CUSTOM_INTEGRATION_CREATE_SCOPE,
  CUSTOM_INTEGRATION_DELETE_SCOPE,
  CUSTOM_INTEGRATION_LIST_SCOPE,
  CUSTOM_INTEGRATION_UPDATE_SCOPE,
} from './constants'

export const useCustomIntegrationScopes = () => {
  const { hasScope } = useZocksAuth()
  const granted = (scope: string): boolean => hasScope('**', scope, [CUSTOM_INTEGRATION_ADMIN_SCOPE])
  return {
    canList: granted(CUSTOM_INTEGRATION_LIST_SCOPE),
    canCreate: granted(CUSTOM_INTEGRATION_CREATE_SCOPE),
    canUpdate: granted(CUSTOM_INTEGRATION_UPDATE_SCOPE),
    canDelete: granted(CUSTOM_INTEGRATION_DELETE_SCOPE),
  }
}
